import {Component, Input, OnInit} from '@angular/core';
import {ExpandCollection} from '@ox/typings';

@Component({
  selector: 'ox-expander-collapse-dynamic-group',
  templateUrl: './expand-collapse-dynamic-group.component.html'
})

export class ExpanderCollapseDynamicGroupComponent implements OnInit {
    @Input() collection: ExpandCollection[];
     loading = true;
    //todo: need ocAppConfig to populate data for search-results-webu   


    ngOnInit() {
      this.loading = typeof(this.collection) === 'object' ? false : true;
    }
  
    trackByCmsTitle(index: number, item: ExpandCollection) {
      return item.cmsTitle;
    }


}
